<template>
  <v-app>
    <v-content>
      <v-container style="padding-top:1rem;padding-bottom:2rem;text-align:center;">
          <div style="margin-top:5rem;">
            <i class="fa fa-check-circle" aria-hidden="true" style="color:#4caf50;font-size:6rem;" v-if="atag === 1"></i>
            <i class="fa fa-exclamation-circle" aria-hidden="true" style="color:#F56C6C;font-size:6rem;" v-else></i>
          </div>
          <div style="margin-top:1rem;font-size:1.1rem;font-weight:bold;">{{text}}</div>
          <div v-if="desc" class="us_desc">{{desc}}</div>
          <div v-if="backBtnVis" style="margin-top:3.5rem;">
            <v-btn color="primary" style="width:80%;" large outlined @click="goBack">返回</v-btn>
          </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      // 图标显示 1-成功,0-失败
      atag: 0,
      // 提示文字
      text: '',
      // 返回方式 a-首页、b-返回上一页、n-不返回、y-返回
      autoRet: 'n',
      // 描述
      desc: '',
      // 返回目标(后退多少页)
      dest: 0,
      // 返回按钮显示 0-false,1-true
      backBtnVis: false,
      // 刷新页面
      refresh: false
    }
  },
  computed: {},
  mounted() {
    var that = this
    var curQuery = that.$route.query
    if (curQuery.tag) {
      that.atag = parseInt(curQuery.tag)
    }
    if (curQuery.auto_ret) {
      that.autoRet = curQuery.auto_ret
    }
    if (curQuery.text) {
      that.text = curQuery.text
    }
    if (curQuery.desc) {
      that.desc = curQuery.desc
    }
    if (curQuery.dest) {
      that.dest = parseInt(curQuery.dest)
    }
    if (curQuery.back_btn_vis) {
      that.backBtnVis = parseInt(curQuery.back_btn_vis) === 1
    }
    if (curQuery.refresh) {
      that.refresh = true
    }
    that.autoBack()
  },
  created() {
  },
  methods: {
    autoBack() {
      var that = this
      if (that.autoRet === 'n') {
        return
      }
      if (that.autoRet === 'a') {
        setTimeout(function() {
          that.$router.replace('/Home')
        }, 1500);
      } else if (that.autoRet === 'b') {
        setTimeout(function() {
          that.$router.goBack(200)
        }, 1500);
      } else if (that.autoRet === 'y') {
        setTimeout(function() {
          that.$router.goBack(that.dest, that.refresh)
        }, 1500);
      }
    },
    goBack() {
      var that = this
      that.$router.goBack(that.dest)
    }
  }
}
</script>

<style scoped>
.us_desc{
  padding-top:0.7rem;
  font-size:0.9rem;
  width:85%;
  margin:auto;
  text-align:center;
  word-wrap:break-word;
  word-break:break-all;
}
</style>
